import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'

import {
  StyledImage,
  StyledCameo,
  StyledImageWrapper,
  StyledIcon,
  StyledInitials
} from './styled'

const Cameo = ({
  image_url = null,
  onClick = () => {},
  showCheckbox = true,
  initials = 'N/A',
  checkbox_tooltip_message = '',
  size = 60,
  border_color = '#1890ff'
}) => {
  const showCameo = image_url !== null

  return (
    <StyledCameo size={size} border_color={border_color} onClick={onClick}>
      {showCameo ? (
        <>
          <StyledImageWrapper>
            <StyledImage
              className="cameo"
              src={image_url}
              alt="cameo"
              size={size}
            />
          </StyledImageWrapper>
          {showCheckbox && (
            <StyledIcon size={size} border_color={border_color} />
          )}
        </>
      ) : (
        <>
          <StyledInitials size={size}>{initials}</StyledInitials>
          {showCheckbox && (
            <Tooltip title={checkbox_tooltip_message}>
              <StyledIcon size={size} border_color={border_color} />
            </Tooltip>
          )}
        </>
      )}
    </StyledCameo>
  )
}

Cameo.propTypes = {
  initials: PropTypes.string,
  image_url: PropTypes.string,
  border_color: PropTypes.string,
  size: PropTypes.number,
  showCheckbox: PropTypes.bool,
  checkbox_tooltip_message: PropTypes.string,
  onClick: PropTypes.func
}

export default Cameo
